import { ServiceTypeService } from './../../services/serviceTypeService';
import { Component, OnInit } from '@angular/core';
import { ServiceType } from '../../models/serviceType';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-add-service-type',
  templateUrl: './add-service-type.component.html',
  styleUrls: ['./add-service-type.component.css'],
})
export class AddServiceTypeComponent implements OnInit {
  sType: ServiceType;
  isLoading: boolean = false;
  constructor(
    private service: ServiceTypeService,
    private diag: NbDialogRef<AddServiceTypeComponent>,
    private toast: NbToastrService,
    private route:Router
  ) {
    this.sType = {} as ServiceType;
    this.sType.nameAr = '';
  }

  ngOnInit(): void {
      this.route.events.subscribe(()=>{
      this.diag.close('false');
  })
  }

  save() {
    this.isLoading = true;
    this.service.post(this.sType).subscribe((res) => {
      this.isLoading = false;
      this.toast.show('تم إضافة نوع اخدمة جديد بنجاح', '', { status: 'success', duration: 4000 });
      this.diag.close('true');
    });
  }
}
